import { styled } from "@mui/material";

export interface LocationContainerProps {
  alignItems?: "flex-start" | "flex-end";
}

export const LocationContainer = styled("div")(
  ({ alignItems = "flex-start" }: LocationContainerProps) => ({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    position: "relative",
    height: "fit-content",
    fontFamily: "Manrope",
    alignItems,

    "&#lastStepPort": {
      "@media (min-width: 1024px)": {
        alignItems: "flex-end",
      },
    },
  })
);

export const CityCountryContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
}));

export const CodeContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
}));

export const PortContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
}));

interface CityCountryLabelProps {
  color: string;
}

export const CityCountryLabel = styled("span")(({ color }: CityCountryLabelProps) => ({
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "24px",
  letterSpacing: "0.15px",
  color,
  paddingRight: "3px",
}));

export const PortLabel = styled("span")(({ color }: CityCountryLabelProps) => ({
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "24px",
  letterSpacing: "0.15px",
  color,
  paddingRight: "3px",
}));

export const CodeLabel = styled("span")(({ color }: CityCountryLabelProps) => ({
  fontSize: "32px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "40px",
  color,
  paddingRight: "3px",
}));

interface ProgressFillProps {
  percentageWidth: number;
}

export const ProgressFill = styled("div")(({ percentageWidth }: ProgressFillProps) => ({
  width: `${percentageWidth}%`,
  backgroundColor: "rgba(0, 85, 164, 1)",
  height: "4px",

  position: "absolute",
  top: "50%",
  transform: "translateY(-1px)",
  zIndex: 4,
}));
